/** @format */

import {subDays} from 'date-fns';

import {isInTheRange} from 'helpers/dateHelpers';

import {ActivePeriod, IsoDate, PlanPeriodInput} from '../types';
import {reducePlanToPeriod} from './reducePlanToPeriod';
import {toIso} from './toIso';

interface Options {
  plans: ReadonlyArray<PlanPeriodInput>;
  today: IsoDate;
}

// На 1-е число текущего периода данных ещё нет → используем предыдущий день.
const getEffectiveDate = (today: IsoDate): IsoDate => {
  const dateObj = new Date(today);
  return dateObj.getUTCDate() === 1 ? toIso(subDays(dateObj, 1)) : today;
};

export const selectActivePeriod = ({plans, today}: Options): ActivePeriod | null => {
  const effectiveDate = getEffectiveDate(today);
  const dateObj = new Date(effectiveDate);

  const plan = plans.find(p =>
    isInTheRange({
      startOn: new Date(p.startOn),
      endOn: p.endOn ? new Date(p.endOn) : undefined,
      currentDate: dateObj,
    }),
  );

  if (!plan) {
    return null;
  }

  return {plan, period: reducePlanToPeriod({plan, currentDate: effectiveDate})};
};
